import { createSlice } from "@reduxjs/toolkit";

const GlobalStatesSlice = createSlice({
  name: "globalStates",
  initialState: {
    snackbarOpen: false,
    snackbarMessage: "",
    loading: false,
    openAddPartner: false,
    openResetDialog: false,
  },
  reducers: {
    Load: (state) => {
      state.loading = !state.loading;
    },
    openSnack: (state) => {
      state.snackbarOpen = !state.snackbarOpen;
    },
    snackMessage: (state, action) => {
      state.snackbarMessage = action.payload;
    },
    toggleOpenAddPartner: (state) => {
      state.openAddPartner = !state.openAddPartner;
    },
    toggleOpenResetDialog: (state) => {
      state.openResetDialog = !state.openResetDialog;
    },
  },
});

export const {
  Load,
  openSnack,
  snackMessage,
  toggleOpenAddPartner,
  toggleOpenResetDialog,
} = GlobalStatesSlice.actions;
export default GlobalStatesSlice.reducer;
